import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NotificationContext, NotificationContextHelper } from 'src/app/helper/notification-context.helper';
import { Subject, Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { ConfirmationDialogService } from 'src/app/confirmation-dialog/confirmation-dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpService } from 'src/app/services/http.service';
import { ModalService } from 'src/app/model/model.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { URLUtils } from '../../urlUtils';
import { ensureActiveSubscription } from 'src/app/shared/subscription-dialog';
import { environment } from 'src/environments/environment';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmPlanComponent } from 'src/app/confirm-plan/confirm-plan.component';
import { SuccessDialogComponent } from 'src/app/success-dialog/success-dialog.component';

@Component({
    selector: 'view-relationship',
    templateUrl: 'view-relationship.component.html',
    styleUrls: ['view-relationship.component.scss'],
    standalone: false
})
export class ViewRelationshipComponent implements OnInit, OnDestroy {
    @Input() data: any;
    @BlockUI()
    blockUI!: NgBlockUI;
    @Output() event = new EventEmitter<string>();
    relationshipData: any = {};
    relationshipList: any[] = [];
    relationshipSubscribe: Subscription = new Subscription;
    activeTab: string = 'individuals';
    showModifyForm: boolean = false;
    showMemberForm: boolean = false;
    showExchange: boolean = false;
    showDelConfirm: boolean = false;
    showDelApproval: boolean = false;
    selectedRel: any = {};
    highlight: string = "";
    searchText: string = "";
    product = environment.product;
    isReverse:boolean=false;
    documents:any=[];
    showConfirm: boolean = false;
    selname: any;
    rel: any;
    //payload: any;
    response: any;
    payload: any;
    role:any;
    filteredGroups:any;
    isMarketplace = false;
    relNextCursor:any;
    relPrevCursor:any;  
    searchTermChanged = new Subject<string>();
    relid:any;
    anchor_id: string = '';   
    highlightSet = new Set<string>();
    successModel: boolean = false;
    isDisplay: boolean = true;
    highlightId: string | null = null;
    catsolo:any;

    getPlan: any;
    getCategory: any;
    restrictedPlans = ['free', 'professional', 'starter'];
    
    constructor(private httpservice: HttpService,
                private router: Router,
                private activeRoute: ActivatedRoute,
                private confirmationDialogService: ConfirmationDialogService,
                private modal: ModalService,private dialog: MatDialog,
                private cd: ChangeDetectorRef,private spinnerService: NgxSpinnerService,
                private toastr: ToastrService) {
    }

  ngOnInit(): void {
    // this.showExchange = false

      this.activeRoute.queryParams.subscribe(qp => {
          this.highlightId = qp['highlightId'] || null;
      }); //highlighting new connections

       this.catsolo = localStorage.getItem('category');
           
       this.getPlan = localStorage.getItem("plan"); // get current plan
       //this.getCategory = localStorage.getItem("category"); // get current category

       
    this.activeRoute.params.subscribe(params => {
      this.activeTab = params['filter']
      this.highlight = params['highlight']

      this.activeRoute.queryParams.subscribe(qp => {
        const tab = qp['tab']; 
        const ctx = NotificationContextHelper.consume();
        // console.log('Notification Context:', ctx);
        // console.log('tab:', tab, 'this.activeTab:', this.activeTab);

        if (ctx) {
          this.handleNotificationFlow(ctx);
        }  

        if (tab === 'sharedWithMe'){ // notification navigation for shared with me
          this.showExchange = true
          this.relationshipData = {
            "id": ctx?.relationship_id,
            "groups": [],
            "client_id":"", 
            "clientType": this.activeTab === 'individuals' ? 'Consumer' : 'Entity'
          }
        }
        else if(tab === 'profile' ) { // matter client profile navigation
          this.showExchange = true
          this.relationshipData = {
            "client_id": qp['clientId'],
            "id": qp['relationshipId'],
            "clientType": qp['clientType'],
            "groups": [],
            "tab": tab,
            "pending": qp["pending"]
          }
        }
        else
          this.loadData() 
       
      });
    });

    var role = localStorage.getItem("role")
    this.role = role

    var is_marketplace = localStorage.getItem("is_marketplace")
    if (is_marketplace == 'true') {
      this.isMarketplace = true;
    }

    this.searchTermChanged.pipe(
      debounceTime(500),      // wait 500ms after the last keystroke
      distinctUntilChanged()  // only if the text is different
    ).subscribe(term => {
      //this.currentPage = 1;  // RESET to first page

      if (term.trim()) {
        this.getSearch(term);
      } else {
        // Optionally fetch all leads again or clear the list
        this.loadData();  // assuming you have a method to get all
      }
    });
    //console.log('activeTab on init:', this.activeTab);
  }


     handleNotificationFlow(ctx: NotificationContext) {  
        if (ctx.highlight_ids?.length) { 
          this.highlightSet = new Set(ctx.highlight_ids);
          this.anchor_id = ctx.highlight_ids[0];  
        }  
      }
    
    openRelationshipIfNeeded() {
        if (!this.relid || !this.relationshipList.length) {
            return;
        }

        const matchedRel = this.relationshipList.find(
            (rel: any) => rel.id === this.relid
        );

        if (matchedRel) {
            this.relationshipData = matchedRel;
            this.showExchange = true;
        }
    }



    getSearch(term: string) {
        const searchParams = { paginate: true, search: term }; // search text
        let url
        
        if (this.product === 'corporate' || this.activeTab === 'corporate') {
            url = URLUtils.getcorporateRelationship;
            this.spinnerService.show();
            this.relationshipSubscribe = this.httpservice.getFeaturesdata(url, searchParams).subscribe(
                (res: any) => {
                    this.relNextCursor = res?.next_cursor;
                    this.relPrevCursor = res?.prev_cursor || res?.previous_cursor;
                    this.spinnerService.hide();

                    this.relationshipList = res.relationships.map((rel: any) => {
                        return {
                            ...rel, // Spread the original properties of `rel`
                            filteredGroups: rel.groups.filter((group: any) => group.name !== 'AAM' && group.name !== 'SuperUser')
                        };
                    });
                    //console.log('Corp-rel:', this.relationshipList)
                })
        }
        else {
            url = URLUtils.getRelationshipFiltered(this.activeTab);
            this.spinnerService.show();
            this.relationshipSubscribe = this.httpservice.getFeaturesdata(url, searchParams).subscribe(
                (res: any) => {
                    //console.log('res-next', res);

                    this.relNextCursor = res?.next_cursor;
                    this.relPrevCursor = res?.prev_cursor || res?.previous_cursor; // handle both possible keys
                    this.spinnerService.hide();

                    this.relationshipList = res.data.relationships.map((rel: any) => ({
                        ...rel,
                        filteredGroups: rel.groups.filter(
                            (group: any) => group.name !== 'AAM' && group.name !== 'SuperUser'
                        ),
                    }));

                    // Trigger change detection manually if needed
                    setTimeout(() => { }, 0);
                },
                (error) => {
                    this.spinnerService.hide();
                    console.error(error);
                }
            );
        }
    }

    onSearchChange(value: string) {
    this.searchTermChanged.next(value);
    }

    // Just reset the tab when clicked.
    tabReset(name: string){
        this.activeTab = name;
        this.searchText='';
        this.showModifyForm = false;
        this.showMemberForm = false; //close form tabs
        this.showExchange = false;
        this.showDelConfirm = false;
        this.showDelApproval = false;
        this.relationshipData = {};
        this.relationshipList = [];
        this.loadData()
    }
    
    loadData(){
        
      let page: {
        paginate: boolean;
        anchor_id?: string;
      } = {
        paginate: true
      };

      if (this.anchor_id) {
        page.anchor_id = this.anchor_id;
      }

        if(this.relid){
            //console.log("this relid")
            page.paginate = false
        }
        //this.toastr.success('Loading data...');
        let url:any;
        this.showExchange = false;
        this.showMemberForm = false;
        this.searchText='';

        this.spinnerService.show();
        if(this.activeTab=='temporary'){
            url  = URLUtils.relationshipTemporary;
            this.relationshipSubscribe = this.httpservice.getFeaturesdata(url).subscribe(
                (res: any) => {
                    this.relNextCursor = res?.next_cursor;
                    this.relPrevCursor = res?.prev_cursor;
                    this.spinnerService.hide();
                    //this.relationshipList = res?.data?.relationships;
                    //this.relationshipList = res?.data;
                    this.relationshipList = res.data.map((rel: any) => {
                        return {
                          ...rel, // Spread the original properties of `rel`
                          filteredGroups: rel.groups.filter((group: any) => group.name !== 'AAM' && group.name !== 'SuperUser')
                        };
                      });
                    //console.log('Temp-rel:',this.relationshipList)
                })
        }
        else if(this.activeTab=='corporate'){
            url  = URLUtils.getcorporateRelationship;
                
            this.relationshipSubscribe = this.httpservice.getFeaturesdata(url,page).subscribe(
                (res: any) => {
                    this.relNextCursor = res?.next_cursor;
                    this.relPrevCursor = res?.prev_cursor;
                    this.spinnerService.hide();
                    //this.relationshipList = res?.relationships;
                    this.relationshipList = res.relationships.map((rel: any) => {
                        return {
                          ...rel, // Spread the original properties of `rel`
                          filteredGroups: rel.groups.filter((group: any) => group.name !== 'AAM' && group.name !== 'SuperUser')
                        };
                      });
                    //console.log('Corp-rel:', this.relationshipList)
                })
        }
        else if(this.activeTab=='deleted'){
            // url  = URLUtils.getDelRelApproval('individuals');
                
            this.spinnerService.show();
            this.relationshipSubscribe = this.httpservice.getFeaturesdata(URLUtils.getDelRelApproval).subscribe(
                (res: any) => {
                    this.spinnerService.hide();

                    this.relNextCursor = res?.next_cursor;
                    this.relPrevCursor = res?.prev_cursor;
                    
                    this.relationshipList = res.data.relationships;
                    this.relationshipList = this.relationshipList.map(item => ({
                        ...item,
                        isHighlighted: this.highlightSet.has(item.id)
                    }));

                    //console.log('del-rel:', this.relationshipList)
                })
        }
        else if(this.activeTab=='marketplace'){
            url  = URLUtils.getmarketplaceRelationship;
            this.relationshipSubscribe = this.httpservice.getFeaturesdata(url).subscribe(
                (res: any) => {
                    this.spinnerService.hide();
                    //this.relationshipList = res?.data?.relationships;
                    //this.relationshipList = res?.data;
                    this.relationshipList = res.relationships.map((rel: any) => {
                        return {
                          ...rel, // Spread the original properties of `rel`
                          filteredGroups: rel.groups.filter((group: any) => group.name !== 'AAM' && group.name !== 'SuperUser')
                        };
                      });
                    //console.log('getmarketplaceRelationship:',this.relationshipList)
                })
        }
        else{
        url  = URLUtils.getRelationshipFiltered(this.activeTab)
        //console.log('URL',url)
        
        this.relationshipSubscribe = this.httpservice.getFeaturesdata(url, page).subscribe(
            (res: any) => {
                //console.log('res1',res)
                this.relNextCursor = res?.next_cursor;
                this.relPrevCursor = res?.prev_cursor;

                this.spinnerService.hide();
                //this.relationshipList = res?.data?.relationships;
                this.relationshipList = res.data.relationships.map((rel: any) => {
                    return {
                      ...rel, // Spread the original properties of `rel`
                      filteredGroups: rel.groups.filter((group: any) => group.name !== 'AAM' && group.name !== 'SuperUser')
                    };
                  });  
                this.relationshipList = this.relationshipList.map(item => ({
                  ...item,
                  isHighlighted: this.highlightSet.has(item.id)
                }));

                //higlighting
                if (this.highlightId) {
                    const rel = this.relationshipList.find((r: any) => r.id === this.highlightId);
                    if (rel) {
                        rel.isHighlighted = true;
                        setTimeout(() => { rel.isHighlighted = false;}, 6000); //  8-seconds
                    }
                }

                this.openRelationshipIfNeeded();
                //console.log('Business-rel:',this.relationshipList)
        })}
    }

    next() {
        if (!this.relNextCursor) {
            //console.log('N-No next page available');
            return;
        }

       // const after = { after: this.relNextCursor, paginate: true };
        let after: any = { after: this.relNextCursor, paginate: true };
        if (this.searchText && this.searchText.trim()) {
            after.search = this.searchText.trim();
        }

        let url
        if (this.product === 'corporate' || this.activeTab === 'corporate') {
            url = URLUtils.getcorporateRelationship;
            this.spinnerService.show();
            this.relationshipSubscribe = this.httpservice.getFeaturesdata(url, after).subscribe(
                (res: any) => {
                    this.relNextCursor = res?.next_cursor;
                    this.relPrevCursor = res?.prev_cursor;
                    this.spinnerService.hide();

                    this.relationshipList = res.relationships.map((rel: any) => {
                        return {
                            ...rel, // Spread the original properties of `rel`
                            filteredGroups: rel.groups.filter((group: any) => group.name !== 'AAM' && group.name !== 'SuperUser')
                        };
                    });
                    //console.log('Corp-rel:', this.relationshipList)
                })
        }
        else {
            url = URLUtils.getRelationshipFiltered(this.activeTab);
            this.spinnerService.show();
            this.relationshipSubscribe = this.httpservice.getFeaturesdata(url, after).subscribe(
                (res: any) => {
                    //console.log('res-next', res);

                    this.relNextCursor = res?.next_cursor;
                    this.relPrevCursor = res?.prev_cursor || res?.previous_cursor; // handle both possible keys
                    this.spinnerService.hide();

                    this.relationshipList = res.data.relationships.map((rel: any) => ({
                        ...rel,
                        filteredGroups: rel.groups.filter(
                            (group: any) => group.name !== 'AAM' && group.name !== 'SuperUser'
                        ),
                    }));

                    // Trigger change detection manually if needed
                    setTimeout(() => { }, 0);
                },
                (error) => {
                    this.spinnerService.hide();
                    console.error(error);
                }
            );
        }
    }

    prev() {
        if (!this.relPrevCursor) {
            //console.log('P-No previous page available');
            return;
        }

        //const before = { before: this.relPrevCursor, paginate: true };
        let before: any = { before: this.relPrevCursor, paginate: true };
        if (this.searchText && this.searchText.trim()) {
            before.search = this.searchText.trim();
        }

        let url
        if (this.product === 'corporate' || this.activeTab === 'corporate') {
            url = URLUtils.getcorporateRelationship;
            this.spinnerService.show();

            this.relationshipSubscribe = this.httpservice.getFeaturesdata(url, before).subscribe(
                (res: any) => {
                    this.relNextCursor = res?.next_cursor;
                    this.relPrevCursor = res?.prev_cursor || res?.previous_cursor;
                    this.spinnerService.hide();

                    this.relationshipList = res.relationships.map((rel: any) => {
                        return {
                            ...rel, // Spread the original properties of `rel`
                            filteredGroups: rel.groups.filter((group: any) => group.name !== 'AAM' && group.name !== 'SuperUser')
                        };
                    });
                    //console.log('Corp-rel:', this.relationshipList)
                })
        }
        else {
            url = URLUtils.getRelationshipFiltered(this.activeTab);
            this.spinnerService.show();
            this.relationshipSubscribe = this.httpservice.getFeaturesdata(url, before).subscribe(
                (res: any) => {
                    //console.log('res-prev', res);

                    this.relNextCursor = res?.next_cursor;
                    this.relPrevCursor = res?.prev_cursor || res?.previous_cursor;

                    this.spinnerService.hide();

                    this.relationshipList = res.data.relationships.map((rel: any) => ({
                        ...rel,
                        filteredGroups: rel.groups.filter(
                            (group: any) => group.name !== 'AAM' && group.name !== 'SuperUser'
                        ),
                    }));

                    // Force UI refresh if using OnPush change detection
                    setTimeout(() => { }, 0);
                },
                (error) => {
                    this.spinnerService.hide();
                    console.error(error);
                }
            );
        }
    }

    accept(rel: any) {
      if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }
        if(this.activeTab=='business' && environment.product != 'corporate'){
            this.httpservice.sendPostRequest(URLUtils.acceptRelationship(rel),
                {}).subscribe((res: any) => {
                    this.loadData()
                    //console.log('formTab', this.activeTab)
                    if(res.error)
                    this.toastr.error(res.msg)
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403) {
                      const errorMessage = error.error.msg || 'Unauthorized';
                      this.toastr.error(errorMessage);
                      //console.log(error);
                    }
                  }
               
            )
        }
        else{  
            let payload = {
                "response":"yes"
            }
            this.httpservice.sendPutRequest(URLUtils.acceptRelationshipCorp(rel), payload
                ).subscribe((res: any) => {
                    this.loadData()
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403) {
                      const errorMessage = error.error.msg || 'Unauthorized';
                      this.toastr.error(errorMessage);
                      //console.log(error);
                    }
                  })
        
        //console.log('activeTab', this.activeTab)
        //console.log('payload', this.payload)
    }
}

    
    ngOnDestroy() {
        if (this.relationshipSubscribe) {
            this.relationshipSubscribe.unsubscribe();
        }
    }

    delrel(rel: any) {
        //console.log("delete rel:", rel)
        this.selectedRel = rel

        // if (rel.isAccepted == true || rel.status == "inactive") 
        //     this.showDelApproval = true
        // else 
        //this.showDelConfirm = true
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            disableClose: true,
            hasBackdrop: true,
            backdropClass: 'backdropBackground',
            data: { title: 'Confirmation', message: `Are you sure you want to delete the relationship request sent by ${this.selectedRel.name} ?` }
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            //console.log('Dialog result:', result);
            if (result) {
                this.deleteRel();
            }
        });
        // this.deleteRel()
    }


    deletePermanent(rel: any) {
        this.selectedRel = rel
        //console.log("this.selectedRel rel:",this.selectedRel)
        

        //this.showDelConfirm = true; 
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            disableClose: true,
            hasBackdrop: true,
            backdropClass: 'backdropBackground',
            data: { title: 'Confirmation', message: `Are you sure you want to delete the relationship request sent to ${this.selectedRel.name} ?` }
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            //console.log('Dialog result:', result);
            if (result) {
                this.deleteRel();
            }
        });   
    }

    activateRel(rel: any) {
      

        this.httpservice.sendPostRequest(URLUtils.deleteRelationshipRestore(rel) ,'').subscribe(
            (res: any) => {
                if(res.error==false){
                    this.toastr.success(res.msg)
                    this.loadData()
                    // this.confirmationDialogService.confirm('Success', `${res.msg}`, false, 'OK', 'Cancel', true).then((confirmed) => {
                    //     if (confirmed)
                    //         this.loadData()
                    // })	
                } else {
                    this.toastr.error(res.msg)
                }     
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) { 
                    const errorMessage = error.error.msg || 'Unauthorized';
                    this.toastr.error(errorMessage);
                    //console.log(error);
                }
            })
    }   

    deleteRel(){
         // console.log("this.selectedRel rel:",this.selectedRel)
         if( this.activeTab == 'deleted'){
            this.httpservice.sendDeleteRequest(URLUtils.deletePermanentRelationship(this.selectedRel)).subscribe(
                (res: any) => {
                    this.showDelConfirm = false;
                    if(res.error==false){
                        this.toastr.success(res.msg)         
                        this.loadData();
                    } else {
                        this.toastr.error(res.msg)
                    }
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403) {
                      const errorMessage = error.error.msg || 'Unauthorized';
                      this.toastr.error(errorMessage);
                      //console.log(error);
                    }
                  })
            return;
         } else {
        this.httpservice.sendDeleteRequest(URLUtils.deleteRelationship(this.selectedRel)).subscribe(
            (res: any) => {
                this.showDelConfirm = false;
                //this.modal.open('delete-update-success')
                //this.toastr.success(res.msg)
                this.dialog.open(SuccessDialogComponent, {
                    width: '400px',
                    data: {
                        title: 'Success',
                        message: res.msg,
                        confirmText: 'OK',
                        cancelText: ''
                    }
                });
                this.loadData()
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                  const errorMessage = error.error.msg || 'Unauthorized';
                  this.toastr.error(errorMessage);
                  //console.log(error);
                }
              })

               }
    }

    // getButtonActive(buttonName:any){
    //   const categoryList=document.getElementsByClassName("relSubTab");
    //   for(let i=0;i<categoryList.length;i++){
    //     if(categoryList[i].classList.contains(buttonName)){
    //       categoryList[i].classList.add('active');
    //     }else{
    //       categoryList[i].classList.remove('active');
    //     }
    //   }
    // }

   
    
    closeModal(id: any) {
        this.modal.close(id);
    }

    openModel(id: any) {
        this.modal.open(id);
    }
    gotoDetail(name: string): void {
        this.activeTab = name
    }

    // ---------------------------------------------------------------------
    // Cases Shared (Individual Relationships only)
    // ---------------------------------------------------------------------

    /**
     * Number of cases shared by this client. Backed directly by the
     * relationship list API's `preReadSharedCount` — never computed on the
     * frontend and never requires a separate API call.
     */
    getCasesSharedCount(rel: any): number {
        return rel?.preReadSharedCount || 0;
    }

    getCasesSharedLabel(rel: any): string {
        const count = this.getCasesSharedCount(rel);
        if (count === 0) { return 'N/A'; }
        return count === 1 ? '1 Case' : `${count} Cases`;
    }

    openCasesShared(rel: any): void {
        if (this.getCasesSharedCount(rel) === 0) {
            return; // N/A is not clickable
        }
        // preReadIds is the relationship's own list of Pre-Read ids — kept
        // distinct from rel.id (relationship id) and rel.client_id. Each id
        // identifies one shared case and is resolved to its Case Information
        // via GET /professional/v3/prereads/shared/{pre_read_id} on the
        // Cases Shared screen (see CaseListComponent).
        this.router.navigate(['/relationship/view/individuals', rel.id, 'cases'], {
            state: {
                clientName: rel.name,
                clientType: rel.clientType,
                preReadIds: rel.preReadIds || []
            }
        });
    }

    modifyGroups(rel: any){
        this.relationshipData = rel;
        this.showModifyForm = true;
    }

    modifyMembers(rel: any){
        this.relationshipData = rel;
        this.showMemberForm = true;
    }

    exchangeInfo(rel: any){
       // console.log("exchange rel:", rel)
        this.relationshipData = rel;
        this.showExchange = true
    }
    openConfirmBox(rel:any){
        this.relationshipData = rel;
        this.showConfirm = true
        this.selname = rel?.name

    }
    send_invite_temp(){
        
        let payload = {
            "client_id": this.relationshipData?.client_id,
            "client_type": this.relationshipData?.clientType
        }
    
        this.blockUI.start()
        this.httpservice.sendPostRequest(URLUtils.ConvertTempClients,payload).subscribe((resp:any)=>{
            if(resp.msg){
                this.showConfirm = false
                this.blockUI.stop()
                this.toastr.success(resp.msg)
                this.loadData()
            } else if(resp.errors){
                this.blockUI.stop()
                for(let error of resp.errors){
                    if(error.field === 'client_type'){
                        // handle error related to client_type field
                        this.toastr.error(`client_type: ${error.msg}`)
                    } else {
                        // handle other error cases
                        this.toastr.error(`client id: ${error.msg}`)
                    }
                }
            }
        },
        (error: HttpErrorResponse) => {
            if (error.status === 401 || error.status === 403) {
              const errorMessage = error.error.msg || 'Unauthorized';
              this.toastr.error(errorMessage);
              //console.log(error);
            }
          }
        )
        
        
    }

    onChildEvent(msg: string){
        if(msg == 'group-access-close'){
            this.showModifyForm = false
        }
        if(msg == 'member-access-done'){
            this.showMemberForm = false
        }
        if(msg == 'group-access-done'){
           this.showModifyForm = false
           this.modal.open('group-update-success')
           this.loadData()
        }
        if(msg == 'exchange-close'){
            this.showExchange = false
        }
    }
    onCloseEvent(){
            this.showModifyForm = false;
            this.showMemberForm = false;
            this.loadData();
    }
    sortingFile(val: any) {
        this.isReverse = !this.isReverse;
        if (this.isReverse) {
            this.relationshipList = this.relationshipList?.sort((p1: any, p2: any) => (p1[val] < p2[val]) ? 1 : (p1[val] > p2[val]) ? -1 : 0);
           
        } else {
            this.relationshipList = this.relationshipList?.sort((p1: any, p2: any) => (p1[val] > p2[val]) ? 1 : (p1[val] < p2[val]) ? -1 : 0);
            
        }
    }
    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
      
      
    isRestrictedPlan(): boolean {
        return this.restrictedPlans.includes((this.getPlan || '').trim().toLowerCase());
    }

    //subscription check for action button
    checkPlan(event?: MouseEvent): boolean {
        const restrictedPlans = ['free', 'professional', 'starter'];

        if (restrictedPlans.includes(this.getPlan)) {
            this.dialog.open(ConfirmPlanComponent, {
                width: '400px',
                data: { plan: this.getPlan }
            });

            return false;   // Stop further execution
        }
        return true;      // Allow further execution
    }

    onClick() {
        //console.log('activeTab',this.activeTab)
        if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }        
        
        if (!this.checkPlan()) {
            return;
        } // Stop here if plan is restricted

        if (this.product === 'corporate' || this.activeTab === 'corporate') {
            this.router.navigate(['/relationship/add/corporate'])
        }
        else if(this.activeTab === 'business'){
            this.router.navigate(['/relationship/add/entity'])
        }
        else{
            this.router.navigate(['/relationship/add/individual'])
        }
        // this.selectedMatter = value;
        // this.selectedMatter == 'legalmatter' ? this.router.navigate(['/matter/legalmatter/create']) : this.router.navigate(['/matter/generalmatter/create']);
    }
    
    hideAndShow() {
        this.isDisplay = !this.isDisplay;
    }

}